"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const with_collapse_1 = require("../../molecules/with-collapse");
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = ({ title, bodyValue, img, isAnswer }) => {
    return ((0, jsx_runtime_1.jsx)(Content, { children: (0, jsx_runtime_1.jsx)(with_collapse_1.WithCollapse, { header: (0, jsx_runtime_1.jsx)(Header, { children: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: title }, void 0) }, void 0), body: isAnswer ? ((0, jsx_runtime_1.jsxs)("div", { children: [bodyValue, img && (0, jsx_runtime_1.jsx)("img", { alt: "lesson_photo", src: img }, void 0)] }, void 0)) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: bodyValue } }, void 0)) }, void 0) }, void 0));
};
const Content = styled_components_1.default.div `
  & > div > div:first-of-type {
    border-bottom: none;
  }

  & > div > div:last-of-type {
    padding: ${({ theme }) => `0 ${theme.spacings.m} ${theme.spacings.m}`};
  }

  & > div > div:last-of-type {
    border: 1px solid ${({ theme }) => theme.colors.silverBase};
    border-radius: ${({ theme }) => theme.utils.radius};
    color: ${({ theme }) => theme.colors.greyLighten40};
    min-height: 160px;
    margin: ${({ theme }) => `0 ${theme.spacings.m} ${theme.spacings.m}`};
    padding: ${({ theme }) => theme.spacings.m};

    & > * {
      color: ${({ theme }) => theme.colors.greyLighten40};
      font-family: inherit;
      font-size: 1rem;
      letter-spacing: -0.11px;
      font-weight: 400;

      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
      hyphens: auto;
    }
    p {
      margin-bottom: 1.5rem;
      line-height: 1.25rem;
    }
  }

  img {
    max-height: 615px;
    margin-top: ${({ theme }) => theme.spacings.m};
    width: auto;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div > div:first-of-type {
      padding: ${({ theme }) => `${theme.spacings.m}`};
    }
  }
`;
const Header = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;
  justify-content: space-between;

  h2 {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=CollapseBehaviourDay.js.map